// Should stay in sync with fileErrorMessageCodes.mjs
export const FILE_ERROR_MESSAGE_CODES = {
  INVALID_FILE: 40401,
  WRONG_FILE_TEMPLATE: 42201,
  INVALID_DATA: 42202
};
